export const classNames = (...classes: (string | boolean | undefined)[]) => {
	return (
		Array.from(new Set(classes.filter((cls): cls is string => Boolean(cls))))
			.join(" ")
			.split(" ")
			// Remove duplicates
			.filter((value, index, self) => self.indexOf(value) === index)
			.join(" ")
	);
};
